import { lang } from "./utilities";
import { init, getByID, getAllRates } from "./rates";

let rates;
const fixedPrepaymentAmount = 0.15;

init().then(function (s) {
    // console.log(s, getByID(5));
    rates = getAllRates();
    // console.log(rates, "RATE-ARR");
});
function fetchRates() {
    // fetch("../common/data/rates.json")
    //     .then((response) => response.json())
    //     .then((data) => {
    //         rates = data.rates;
    //     })
    //     .catch((err) => console.err(err));
}

const dynamicText = {
    en: {
        base: "Based on the information you provided the estimated prepayment charge to",
        prepayText: "prepay**",
        payoutText: "payout*",
        yourMortgageText: "your mortgage is",
        adminFeeText: "an administration fee",
        capRate: "3 months interest at the cap rate",
        differentialCharge: "an interest rate differential charge",
        threeMonthsRate: "3 months interest at the mortgage rate",
    },
    fr: {
        base: "Selon vos données, les frais estimatifs pour rembourser",
        prepayText: "par anticipation** votre prêt sont",
        payoutText: "intégralement* votre prêt hypothécaire",
        yourMortgageText: "",
        adminFeeText: "des frais administratifs",
        capRate: "3 mois d’intérêts au taux plafond",
        differentialCharge: "des frais de différence de taux d’intérêt",
        threeMonthsRate: "3 mois d’intérêts au taux hypothécaire",
    },
};

function getPartialPrePaymentWithoutCharge(originalMortgage) {
    return originalMortgage * fixedPrepaymentAmount;
}

function getOpenTermFee(mortgageAgeMonths) {
    return mortgageAgeMonths <= 12 ? 200 : 0;
}

function getScotiaCurrentRateForSameClosestTerm(monthsRemaining, isOpen) {
    if (!isOpen) {
        return (
            rates.find(
                (el) =>
                    el.serverMap != "1O" &&
                    el.serverMap != "6O" &&
                    el.start <= monthsRemaining &&
                    el.end >= monthsRemaining,
            ).value / 100
        );
    } else {
        return (
            rates.find(
                (el) =>
                    (el.serverMap == "1O" || el.serverMap == "6O") &&
                    el.start <= monthsRemaining &&
                    el.end >= monthsRemaining,
            ).value / 100
        );
    }
}

function getScotiaComparableTerm(monthsRemaining) {
    return rates.find((el) => el.start <= monthsRemaining && el.end >= monthsRemaining);
}

function getThreeMonthsInterestCosts({ prepayment, originalMortgage, payoutBalanceAmount, usedRate, isPrepayment }) {
    if (!isPrepayment) {
        return (payoutBalanceAmount * usedRate) / 4;
    }

    const payment = Math.min(prepayment, payoutBalanceAmount);

    return ((payment - fixedPrepaymentAmount * originalMortgage) * usedRate) / 4;
}

function getIRDWork({
    isPrepayment,
    prepayment,
    originalMortgage,
    payoutBalanceAmount,
    monthsRemaining,
    discountRate,
    customerInterestRate,
    isOpen,
}) {
    const scotiaCurrentRate = getScotiaCurrentRateForSameClosestTerm(monthsRemaining, isOpen);
    // console.log(scotiaCurrentRate, "----currRate")

    if (isPrepayment) {
        return (
            (customerInterestRate - (scotiaCurrentRate - discountRate)) *
            (Math.min(prepayment, payoutBalanceAmount) - originalMortgage * fixedPrepaymentAmount) *
            (monthsRemaining / 12)
        );
    }

    return ((customerInterestRate - (scotiaCurrentRate - discountRate)) * payoutBalanceAmount * monthsRemaining) / 12;
}

function getUsedRate({ variableRate, capRate, customerInterestRate }) {
    if (variableRate === 12) {
        return capRate;
    }

    return customerInterestRate;
}

function getIRD({
    isPrepayment,
    prepayment,
    originalMortgage,
    payoutBalanceAmount,
    monthsRemaining,
    discountRate,
    customerInterestRate,
    isOpen,
}) {
    const irdWork = getIRDWork({
        isPrepayment,
        prepayment,
        originalMortgage,
        payoutBalanceAmount,
        monthsRemaining,
        discountRate,
        customerInterestRate,
        isOpen,
    });

    if (isPrepayment && prepayment <= originalMortgage * fixedPrepaymentAmount) {
        return 0;
    }

    return irdWork;
}

function getOriginalTermInMonths(rate, isFixedRate) {
    // if (isFixedRate) {
    switch (rate) {
        case 0:
        case 1:
            return 6;
        case 2:
        case 3:
            return 12;
        case 4:
            return 24;
        case 5:
        case 12:
            return 36;
        case 6:
            return 48;
        case 7:
        case 10:
        case 11:
            return 60;
        case 8:
            return 84;
        case 9:
            return 120;
    }
    // }

    // Variable Rate
    // switch (rate) {
    //     case 3:
    //         return 36;
    //     case 5:
    //         return 60;
    // }
}

function timeSinceTakingMortgageInMonths(originalDate) {
    const now = new Date();
    let months = (now.getFullYear() - originalDate.getFullYear()) * 12;

    months -= originalDate.getMonth();
    months += now.getMonth();

    return months <= 0 ? 0 : months;
}

function getCashback({ monthsRemaining, rate, isFixed, cashback }) {
    const originalTermInMonths = getOriginalTermInMonths(rate, isFixed);
    const cashbackAmount = (monthsRemaining / originalTermInMonths) * cashback;

    if (cashbackAmount <= 0) {
        return 0;
    }

    return cashbackAmount;
}

function getCharge({ mortgageAgeMonths, monthsRemaining, rate, isFixed, ird, threeMonthsInterestCosts, isOpen }) {
    const originalTermInMonths = getOriginalTermInMonths(rate, isFixed);

    if (!isOpen) {
        if (
            (rate === 10 && !isFixed) ||
            (rate === 11 && !isFixed) ||
            (rate === 12 && !isFixed) ||
            (originalTermInMonths >= 84 && originalTermInMonths - monthsRemaining >= 60)
        ) {
            return threeMonthsInterestCosts;
        } else {
            return Math.max(ird, threeMonthsInterestCosts);
        }
    }

    return getOpenTermFee(mortgageAgeMonths);
}

function payoutPrepayLogic({
    originalMortgage,
    currentBalance,
    prepayment,
    rate,
    isFixed,
    isOpen,
    isPrepayment,
    monthsRemainingOnCurrentTerm,
    currentRate,
    discountRate,
    capRate,
    cashback,
    originalDate,
}) {
    const mortgageAgeMonths = timeSinceTakingMortgageInMonths(originalDate);
    const usedRate = getUsedRate({ variableRate: !isFixed && rate, capRate, customerInterestRate: currentRate });
    const originalTermInMonths = getOriginalTermInMonths(rate, isFixed);
    const threeMonthsInterestCosts = getThreeMonthsInterestCosts({
        prepayment,
        originalMortgage,
        payoutBalanceAmount: currentBalance,
        usedRate,
        isPrepayment,
    });
    const ird = getIRD({
        isPrepayment,
        prepayment,
        originalMortgage,
        payoutBalanceAmount: currentBalance,
        monthsRemaining: monthsRemainingOnCurrentTerm,
        discountRate,
        customerInterestRate: currentRate,
        isOpen,
    });
    let charge = 0;
    if (!isOpen && isFixed) {
        const scotiaCurrentRate = getScotiaCurrentRateForSameClosestTerm(monthsRemainingOnCurrentTerm, isOpen);
        const dicountedComparableRate = currentRate - (scotiaCurrentRate - discountRate);
        // if (dicountedComparableRate <= -0.03) return 0;
        charge =
            dicountedComparableRate <= -0.03
                ? 0
                : Math.max(
                      0,
                      getCharge({
                          mortgageAgeMonths,
                          monthsRemaining: monthsRemainingOnCurrentTerm,
                          rate,
                          isFixed,
                          ird,
                          threeMonthsInterestCosts,
                          isOpen,
                      }),
                  );
    } else {
        charge = Math.max(
            0,
            getCharge({
                mortgageAgeMonths,
                monthsRemaining: monthsRemainingOnCurrentTerm,
                rate,
                isFixed,
                ird,
                threeMonthsInterestCosts,
                isOpen,
            }),
        );
    }

    const cashbackAmount = isPrepayment
        ? 0
        : getCashback({ monthsRemaining: monthsRemainingOnCurrentTerm, rate, isFixed, cashback });

    const partialPrepayment = getPartialPrePaymentWithoutCharge(originalMortgage);

    const textResults = dynamicText[lang];

    let text = "";
    if (rate === 12 && !isFixed) {
        text = textResults.capRate;
    } else {
        if (
            (originalTermInMonths >= 84 && originalTermInMonths - monthsRemainingOnCurrentTerm >= 60) ||
            rate === 10 ||
            (rate === 11 && !isFixed)
        ) {
            text = textResults.threeMonthsRate;
        } else {
            if (ird > threeMonthsInterestCosts) {
                text = textResults.differentialCharge;
            } else {
                text = textResults.threeMonthsRate;
            }
        }
    }

    const dynamicResultText = `${textResults.base} ${isPrepayment ? textResults.prepayText : textResults.payoutText} ${
        textResults.yourMortgageText
    } ${isOpen ? textResults.adminFeeText : text}`;

    // console.log(resultText);
    return {
        charge,
        cashbackAmount,
        partialPrepayment,
        dynamicResultText,
    };
}

function getInterestRateDifferentialValues({ monthsRemainingOnCurrentTerm, currentRate, discountRate }) {
    const comparableTerm = getScotiaComparableTerm(monthsRemainingOnCurrentTerm);
    const comparableRate = comparableTerm.value / 100;
    const closestRemainingTerm =
        comparableTerm.equivalentRemainingTerm === 0.5
            ? `6 ${lang === "en" ? "months" : "mois"}`
            : `${comparableTerm.equivalentRemainingTerm * 12} ${lang === "en" ? "months" : "mois"}`;
    const comparableInterestRate = comparableRate - discountRate;
    const interestRateDifference = currentRate - comparableInterestRate;
    const discountRate2 = discountRate === 0 ? 0 : -discountRate;
    return {
        closestRemainingTerm,
        comparableRate,
        comparableInterestRate,
        interestRateDifference,
        discountRate2,
    };
}

export { fetchRates, payoutPrepayLogic, getPartialPrePaymentWithoutCharge, getInterestRateDifferentialValues };
